import React, {useEffect, useState} from 'react';
import './styles.css';
import TextInput from '../../../uiToolkit/Inputs/TextInput';
import {createMicrolessonText} from '../createMicrolessonText';
import TextAreaInput from '../../../uiToolkit/Inputs/TextAreaInput';
import ToggleSwitch from '../../../uiToolkit/Inputs/ToggleSwitch';
import NumbersInput from '../../../uiToolkit/Inputs/NumbersInput';
import Button from '../../../uiToolkit/Buttons/Button';
import {
  CreateMicrolessonModel,
  Microlesson,
} from '../../../data/models/Microlessons/Microlesson';
import FileUploadSection from '../components/FileUploadSection';
import {hasValue} from '../../../utils/typecheck';

const ASSESMENT_OPTIONS = [
  {
    key: '1',
    value: 'Enabled',
  },
  {
    key: '2',
    value: 'Disabled',
  },
];

interface Props {
  onCancel: () => void;
  onCreate: (
    model: CreateMicrolessonModel,
    avatar?: File,
    navigateNext?: boolean,
  ) => void;
  isLoading: boolean;
  microlesson?: Microlesson;
}

const CreateMicrolessonUI = React.memo(
  ({onCancel, onCreate, isLoading, microlesson}: Props) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [assesment, setAssesment] = useState('1');
    const [passingScore, setPassingScore] = useState<number | undefined>(50);
    const [avatarFile, setAvatarFile] = useState<File>();

    useEffect(() => {
      if (microlesson) {
        setTitle(microlesson.title);
        setDescription(microlesson.description);
        if (hasValue(microlesson.passingScore)) {
          setPassingScore(microlesson.passingScore);
        }
        if (microlesson.isGradable) {
          setAssesment('1');
        } else {
          setAssesment('2');
        }
      }
    }, [microlesson]);

    const onSave = (navigateNext?: boolean) => {
      onCreate(
        {
          title,
          description,
          isGradable: assesment === '1',
          passingScore,
        },
        avatarFile,
        navigateNext,
      );
    };

    return (
      <div className="CreateMicrolessonModal">
        <div className="CreateMicrolessonBody">
          <FileUploadSection
            avatarFile={avatarFile}
            setAvatarFile={setAvatarFile}
            existingAvatar={microlesson?.poster}
          />
          <div className="CreateMicrolessonInputs">
            <p className="InputHeading">
              {createMicrolessonText.titleHeading}
              <span className="MandatoryIndicator">*</span>
            </p>
            <TextInput
              value={title}
              onChange={setTitle}
              placeholder={createMicrolessonText.titlePlaceholder}
              className="MicrolessonInput"
              maxCharacters={40}
            />
            <p className="InputHeading">
              {createMicrolessonText.descriptionHeading}
              <span className="MandatoryIndicator">*</span>
            </p>
            <TextAreaInput
              value={description}
              onChange={setDescription}
              placeholder={createMicrolessonText.descriptionPlaceholder}
              className="MicrolessonInput"
              maxCharacters={300}
            />
            {!microlesson && (
              <>
                <p className="InputHeading">
                  {createMicrolessonText.assessmentHeading}
                </p>
                <p className="InputInfo">
                  {createMicrolessonText.assesmentInfo}
                </p>
                <ToggleSwitch
                  options={ASSESMENT_OPTIONS}
                  selectedOption={assesment}
                  onChange={setAssesment}
                  className="MicrolessonInput"
                />
              </>
            )}
            {assesment === '1' && (
              <>
                <p className="InputHeading">
                  {createMicrolessonText.passingScoreHeading}
                </p>
                <p className="InputInfo">
                  {createMicrolessonText.passingScoreInfo}
                </p>
                <NumbersInput
                  value={passingScore}
                  setValue={setPassingScore}
                  className="MicrolessonsNumbersInput"
                />
              </>
            )}

            <div className="Footer">
              <Button
                title={createMicrolessonText.cancel}
                uiType="text"
                onClick={onCancel}
              />
              <Button
                title={createMicrolessonText.saveAndClose}
                uiType="hollow"
                onClick={() => onSave(false)}
                disabled={!title}
                isLoading={isLoading}
              />
              <Button
                title={createMicrolessonText.nextStep}
                onClick={() => onSave(true)}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    );
  },
);

export default CreateMicrolessonUI;
